

<template>
  <div class="input-content">
    <el-input 
    :placeholder="getPlaceholdText(item.placeholder, 0)"  
    clearable
    v-model="selectList[item.prop].startNum"
    size="small"
    oninput="value=value.replace(/[^\d]/g,'')"
    @blur="checkNum(true)"
    ></el-input>
    <span></span>
    <el-input 
    :placeholder="getPlaceholdText(item.placeholder, 1)" 
    clearable
    v-model="selectList[item.prop].endNum"
    size="small"
    oninput="value=value.replace(/[^\d]/g,'')"
    @blur="checkNum(false)"
    ></el-input>
  </div>
</template>

<script>
  export default {
    name: "rangeSelection",
    props: ['item', "selectList"],
    data(){
      return {

      }
    },
    methods: {
       // 获取日期中占位文字
    getPlaceholdText(str, index) {
      if (str.search('/') != -1) {
       const arr =  str.split('/');
       return arr[index];
      }else {
        return index == 0 ? "开始日期" : "结束日期";
      }
    },
    checkNum(isStart) {
      /**
       * 001 转成 1
       * 都为空时进行比较 后面值大于前面
       */ 
      console.log(this.$utils.isEmpty(this.selectList[this.item.prop].endNum), this.$utils.isEmpty(this.selectList[this.item.prop].startNum));

      if (!this.$utils.isEmpty(this.selectList[this.item.prop].startNum)&& !this.$utils.isEmpty(this.selectList[this.item.prop].endNum)) {
        if (Number(this.selectList[this.item.prop].startNum) > Number(this.selectList[this.item.prop].endNum)) {
            this.$message.warning('最大值需大于最小值');
            if (isStart) {
              this.selectList[this.item?.prop].startNum = null
            } else {
              this.selectList[this.item?.prop].endNum = null
            }
            return;
        } 
      }
      if (isStart && !this.$utils.isEmpty(this.selectList[this.item.prop].startNum))  {
        this.selectList[this.item.prop].startNum = Number(this.selectList[this.item.prop].startNum);
      }
      if (!isStart && !this.$utils.isEmpty(this.selectList[this.item.prop].endNum))  {
        this.selectList[this.item.prop].endNum = Number(this.selectList[this.item.prop].endNum);
      }
    }
    }
  }
</script>

<style lang="scss" scoped>
  .input-content{
     display: flex;
     height: 32px;
     align-items: center;
  }
  span {
    height: 1px;
    width: 30px;
    margin: 0 10px;
    color: black;
    background-color: black;
  }
</style>
